'use client'

/**
 * Fetch helper that adds the user token to the request
 * @param {*} path - the api endpoint path excluding the base url
 * @param {*} options - the fetch options
 * @param {*} user - the user containing the user.token
 * @returns the fetch response
 */
export const fetcher = async (
  path,
  options,
  context,
  setContentType = true,
) => {
  if (options.headers) {
    options.headers.append('Authorization', 'Bearer ' + context.user.token)
    if (!options.headers.has('Content-Type') && setContentType) {
      options.headers.append('Content-Type', 'application/json')
    }
  } else {
    const headers = new Headers()
    headers.append('Authorization', 'Bearer ' + context.user.token)
    if (setContentType) headers.append('Content-Type', 'application/json')
    options.headers = headers
  }

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + path, options)

  // Handle 401 Unauthorized: redirect to login, but still return the real 401 Response.
  // Returning undefined here made callers that read res.status / res.json() crash with
  // "Cannot read properties of undefined" instead of handling the auth failure cleanly.
  if (res.status === 401) {
    context.router.push(
      '/?from=' + encodeURIComponent(context.pathname),
      'replace',
    )
    return res
  }

  return res
}
